<template>
	<div>
		<van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" fixed>
		</van-nav-bar>
		<div class="form-box">
			<table-grid :table-name="tableName" :data-id="dataId" :grouping="grouping" :default-value="defaultValue" @savecomplate="onClickLeft"></table-grid>
		</div>
	</div>
</template>

<script>
	import {
		NavBar,
		Button,
		Toast,
		Icon,
		Dialog,
		Popup
	} from 'vant';
	import moment from "moment";
	import saleChanceService from "../service/saleChanceService";
	import tabs from "../components/Tabs";
	export default {
		data() {
			return {
				title: '编辑',
				id: '',
				dynamicTabId: '',
				hostId: '',
				dataId: '',
				tableName: '',
				workflowTemplateId: '',
				grouping: false,
				defaultValue: {}
			};
		},
		components: {
			tabs,
			[NavBar.name]: NavBar,
			[Button.name]: Button,
			[Icon.name]: Icon,
			[Dialog.name]: Dialog,
			[Popup.name]: Popup
		},
		computed: {

		},
		created: async function() {

			this.tableName = this.$route.query.tableName;
			this.dataId = this.$route.query.uuid;
			this.hostId = this.$route.query.hostId;
			this.id = this.$route.query.id;
			this.defaultValue = JSON.parse(this.$route.query.defaultValue);
			if (this.dataId == "0") {
				this.title = '新建';
			}
		},
		methods: {
			onClickLeft() {
				this.$router.go(-1);
			},

		}
	}
</script>

<style>
	.van-popup--right {
		width: 100%;
		height: 100%;
	}

	.form-box {
		margin-top: 120px;
	}
</style>
